/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import React, {useEffect, useState} from 'react';

import moment from 'moment';
import {batch, useDispatch} from 'react-redux';

import * as setupActions from '@/actions/setupActions';
import {usbOpenFor, usbProperties, selectedDateBeginExport, selectedDateEndExport} from '@/actions/setupActions';
import DateIcon from '@/assets/icons/Calendar.svg';
import CompleteLogsIcon from '@/assets/icons/CompleteLogs.svg';
import ProfileHistoryIcon from '@/assets/icons/ProfileHistoryPC.svg';
import Button from '@/components/button/Button';
import DateTime from '@/components/dateTimePicker/DateTimePicker';
import {HISTORY_SHOW_DATE, HISTORY_SHOW_TYPE_DATE_RANGE} from '@/constants/enums';
import * as PCConstAppData from '@/constants/pcConstAppData';
import * as APPDATA from '@/constants/pcConstAppData';
import UseUsb from '@/hooks/useUsb';
// import PipeOnlyCleaningIcon from "../@/assets/icons/Pipe-Only-Cleaning-Orange.svg";

import './LogMenuPage.less';

function LogMenuPage() {
  const {usbList, RefreshUsbList} = UseUsb();
  const [isDisplayFromDate, setIsDisplayFromDate] = useState(false);
  const [isDisplayToDate, setIsDisplayToDate] = useState(false);
  const [fromDate, setFromDate] = useState(new Date());
  const [toDate, setToDate] = useState(new Date());
  const [fromDateStr, setFromDateStr] = useState(null);
  const [toDateStr, setToDateStr] = useState(null);
  const [isButtonDisabled, setIsButtonDisabled] = useState(true);

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setupActions.updateActiveMenu(PCConstAppData.SYSTEM_LOG));
    const backButtonProperties = {
      id: 'btn-back-cycle-log',
      label: '',
      disabled: false,
      onClick: () => {
        window.location.href = PCConstAppData.HOME_SCREEN_ADDRESS;
      },
    };
    const titleMenuProperties = PCConstAppData.SYSTEM_LOGS_SHORT;
    TopMenuSetup(backButtonProperties, titleMenuProperties);
  }, []);

  useEffect(() => {
    if (fromDateStr && toDateStr) {
      setIsButtonDisabled(false);
    }
  }, [fromDateStr, toDateStr]);

  useEffect(() => {
    if (fromDateStr !== null) {
      if (fromDate > toDate) {
        setAllFromDates(toDate);
      }
    }
  }, [toDate]);

  useEffect(() => {
    if (toDateStr !== null) {
      if (fromDate > toDate) {
        setAllToDates(fromDate);
      }
    }
  }, [fromDate]);

  useEffect(() => {
    if (usbList.length > 0) {
      batch(() => {
        dispatch(usbOpenFor(APPDATA.USB_OPEN_FOR.EXPORT_SYSTEM_LOGS));
        dispatch(usbProperties(usbList));
        dispatch(selectedDateBeginExport(fromDateStr));
        dispatch(selectedDateEndExport(toDateStr));
      });
      window.location.href = APPDATA.USB_FOLDER_LIST_ADDRESS_SYSTEM_LOG;
    }
  }, [usbList]);

  const date2String = (dateInput) =>
    dateInput.toLocaleDateString('en-US', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
    });

  const setAllFromDates = (dateInput) => {
    setFromDate(dateInput);
    setFromDateStr(date2String(dateInput));
  };

  const setAllToDates = (dateInput) => {
    setToDate(dateInput);
    setToDateStr(date2String(dateInput));
  };

  const limitCalendarDateRange = (current) =>
    current.isAfter(moment().subtract(60, 'day')) && current.isBefore(moment());

  const OnDateSelectionChangeActionHandler = (id, selectedDate) => {
    switch (id) {
      case HISTORY_SHOW_TYPE_DATE_RANGE.SEARCH_FILTER_BEGIN:
        setIsDisplayFromDate(false);
        setAllFromDates(selectedDate);
        console.log('selectedDate (From): ', selectedDate);
        break;
      case HISTORY_SHOW_TYPE_DATE_RANGE.SEARCH_FILTER_END:
        setIsDisplayToDate(false);
        setAllToDates(selectedDate);
        console.log('selectedDate (To): ', selectedDate);
        break;
      default:
        break;
    }
  };

  /* --------------------- LIMIT ---------------------*/
  const TopMenuSetup = (backButtonProperties, titleMenuProperties) => {
    batch(() => {
      dispatch(
        setupActions.setTopMenuProperties({
          topButtonProperties: undefined,
          backButtonProperties: {
            id: backButtonProperties.id,
            label: backButtonProperties.label,
            disabled: backButtonProperties.disabled,
            onClick: backButtonProperties.onClick,
          },
          titleMenuProperties,
          topButtonSecondaryButtonProperties: undefined,
          topButtonTertiaryProperties: undefined,
        }),
      );
      // dispatch(setupActions.topButtonTertiaryProperties(undefined));
    });
  };

  /* --------------------- LIMIT ---------------------*/
  return (
    <>
      <div className="menuRules">
        <div>
          <img
            alt={ProfileHistoryIcon}
            src={ProfileHistoryIcon}
            height={75}
            width={75}
            className="icon"
          />
        </div>
        <div>
          <div>
            <p className="header">{APPDATA.CYCLE_HISTORY}</p>
          </div>
          <div>
            <p className="paragraph">
              {' '}
              {`${APPDATA.CYCLE_HISTORY} contains records of all profiles that have been run by the instrument.`}
            </p>
          </div>
          <div className="rowButton">
            <Button
              id={APPDATA.VIEW_CYCLE_HISTORY}
              onClick={() => {
                window.location.href = APPDATA.CYCLE_HISTORY_ADDRESS;
              }}
              className="button"
              label={APPDATA.VIEW_CYCLE_HISTORY.toUpperCase()}
            />
          </div>
        </div>
      </div>
      <div className="menuRules">
        <div>
          <img
            alt={CompleteLogsIcon}
            src={CompleteLogsIcon}
            height={75}
            width={75}
            className="icon"
          />
        </div>
        <div>
          <div>
            <p className="header">{APPDATA.SYSTEM_LOGS}</p>
          </div>
          <div>
            <p className="paragraph">{`${APPDATA.SYSTEM_LOGS} includes all of the system records since the device was turned on.`}</p>
          </div>
          <div>
            <div className="inputContainer">
              <input
                id={HISTORY_SHOW_DATE.START}
                value={fromDateStr || 'Start Date'}
                onClick={() => {
                  setIsDisplayFromDate(true);
                }}
                readOnly
                disabled={false}
                className="inputStyle"
              />

              <img
                alt={DateIcon}
                src={DateIcon}
                onClick={() => {
                  setIsDisplayFromDate(true);
                }}
                className="inputIcon"
              />
            </div>
            <div className="inputContainer">
              <input
                id={HISTORY_SHOW_DATE.END}
                value={toDateStr || 'End Date'}
                onClick={() => {
                  setIsDisplayToDate(true);
                }}
                readOnly
                disabled={false}
                className="inputStyle"
              />
              <img
                alt={DateIcon}
                src={DateIcon}
                onClick={() => {
                  setIsDisplayToDate(true);
                }}
                className="inputIcon"
              />
            </div>
            <Button
              id={APPDATA.EXPORT}
              onClick={() => {
                RefreshUsbList();
              }}
              disabled={isButtonDisabled}
              className={isButtonDisabled ? 'buttonInactive' : 'buttonActive'}
              label={APPDATA.EXPORT.toUpperCase()}
            />
          </div>
        </div>
      </div>
      <div className="logPageDate">
        <DateTime
          id={HISTORY_SHOW_TYPE_DATE_RANGE.SEARCH_FILTER_BEGIN}
          showDateTime={isDisplayFromDate}
          onClose={OnDateSelectionChangeActionHandler}
          dateFormat={DateTime.format.date}
          timeFormat={false}
          isValidDate={limitCalendarDateRange}
          value={fromDate}
        />
      </div>
      <div className="logPageDate">
        <DateTime
          id={HISTORY_SHOW_TYPE_DATE_RANGE.SEARCH_FILTER_END}
          showDateTime={isDisplayToDate}
          onClose={OnDateSelectionChangeActionHandler}
          dateFormat={DateTime.format.date}
          timeFormat={false}
          isValidDate={limitCalendarDateRange}
          value={toDate}
        />
      </div>
    </>
  );
}

export default LogMenuPage;

// DONE: CENTER BOTH THE PROFILE HISTORY AND SYSTEM LOG BOX #21405
// DONE: Combine OnFromDateSelectionChangeActionHandler and OnToDateSelectionChangeActionHandler to OnDateSelectionChangeActionHandler
// DONE: If user selects and 'end date' that precedes the 'start date', then 'start date' will change to be the same as the 'end date' #21590
// DONE: Likewise, if user selects and 'start date' that succeeds the 'end date', then 'end date' will change to be the same as the 'start date' #21590
// DONE: Limit the date pick to the last 60 days #21592
// DONE: Top menu show as System log instead LOG #21407
// DONE: set dependency to initial useEffect, as to triggering this useEffect again each time this route is visited or,
// DONE: add setTopMenuProperties (#21427, #21419, #21417, #21413, #21408)

/* TODO: Restructure directorial hierarchy such as that cycleHistory and systemLog
are both under logMenuPage, as illustrated as follow:

        views/
        ├─ advancedSetup/
        ├─ ...
        ├─ ..
        ├─ .
        ├─ logMenuPage/
        │  ├─ LogMenuPage.js
        │  ├─ LogMenuPage.less
        │  ├─ cycleHistory/
        │  │  ├─Business/
        │  │  ├─CycleHistory.data.js
        │  │  ├─CycleHistoryBottomMenu.jsx
        │  │  ├─...
        │  │  ├─..
        │  │  ├─.
        │  ├─ systemLog/
        │  │  ├─Business/
        │  │  ├─SystemLog.js
        │  │  ├─SystemLog.less
        │  │  ├─...
        │  │  ├─..
        │  │  ├─.
        ├─ ...
        ├─ ..
        ├─ .
        ...
        ..
        .                           */

// TODO:
// TODO:
// TODO:
// TODO:
// TODO:
// TODO:
// TODO:
// TODO:
